module.exports = __webpack_public_path__ + "static/fonts/Nunito-ExtraLight.699119e.woff";